//
// Copyright 2025 DXOS.org
//

// @import-as-namespace

import * as Schema from 'effect/Schema';

import { DXN, Obj, Type } from '@dxos/echo';

/**
 * Expando object is an object with an arbitrary set of properties.
 */
export class Expando extends Type.makeObject<Expando>(DXN.make('org.dxos.type.expando', '0.1.0'))(
  Schema.StructWithRest(Schema.Struct({}), [Schema.Record(Schema.String, Schema.Any)]),
) {}

export const make = <T extends Record<string, unknown>>(props: T = {} as T, id?: Obj.ID) =>
  Obj.make(Expando, { id, ...props });
